import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from '@/contexts/I18nContext';
import { ProfileSection } from './ProfileSection';
import { SecuritySection } from './SecuritySection';
import { DangerZoneSection } from './DangerZoneSection';

export const AccountSettings: React.FC = () => {
  const { t } = useTranslation();
  const { userProfile, isAuthenticated } = useAuth();

  if (!isAuthenticated || !userProfile) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center text-muted-foreground">
            {t('settings.pleaseLogin')}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {/* 个人资料部分 */}
      <ProfileSection user={userProfile.user} />
      
      {/* 安全设置部分 */}
      <SecuritySection user={userProfile.user} />
      
      {/* 危险区域 */}
      <DangerZoneSection />
    </div>
  );
};
